export default __webpack_public_path__ + "static/media/EyeIcon.5878a1fa.svg";